import { useQueryWithUserId } from '@northladder/services';

import { CUSTOMER_SERVICE_API } from '../customerServiceClient';

/**
 * This is to track the bid execution time query key in react query cache.
 */
const BID_EXECUTION_TIME_KEY = 'bid-execution-time-key';

/**
 * `useBidExecutionTimeQuery` handles the API call to get the bid execution time.
 */
export const useBidExecutionTimeQuery = () => {
  const { data, error, isError, isPending, refetch } = useQueryWithUserId({
    queryKey: [BID_EXECUTION_TIME_KEY],
    enabled: true,
    queryFn: () => CUSTOMER_SERVICE_API.getBidExecutionTime(),
  });

  return {
    data,
    error,
    isError,
    isPending,
    refetch,
  };
};
